import { useContext, useMemo } from 'react';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';

export default function useGetMostViewedOrMostRecentYMM() {
  const {
    recentVehiclesFromSearch: { data: recentVehicles }
  } = useContext(RecentVehiclesContext);

  return useMemo(() => {
    if (recentVehicles.length === 0) return null;

    // Count occurrences of each ymm
    const ymmCounts = recentVehicles.reduce<Record<string, number>>(
      (counts, vehicle) => {
        const ymm = `${vehicle.year}-${vehicle.make}-${vehicle.model}`;
        counts[ymm] = (counts[ymm] || 0) + 1;

        return counts;
      },
      {}
    );

    const countValues = Object.values(ymmCounts);

    // Check if all counts are the same
    const allCountsEqual = countValues.every(val => val === countValues[0]);

    if (allCountsEqual) {
      // If all counts are the same, return the first vehicle
      return recentVehicles[0];
    }

    // Find the ymm with the highest count
    const mostViewedYMM = Object.keys(ymmCounts).reduce((a, b) =>
      ymmCounts[a] > ymmCounts[b] ? a : b
    );

    // Split the ymm string into its components
    const [year, make, model] = mostViewedYMM.split('-');

    // Find the first vehicle that matches the most viewed ymm
    const mostViewedVehicle = recentVehicles.find(
      vehicle =>
        vehicle.year.toString() === year &&
        vehicle.make === make &&
        vehicle.model === model
    );

    return mostViewedVehicle || recentVehicles[0];
  }, [recentVehicles]);
}
